import { useEffect, useRef, useState } from "react";
import { ENGINE_ORDER } from "./engines";

const IDLE_MS = 20000;

// Auto engine tour: when nobody has clicked, tapped, scrolled or pressed a key for 20 s, each finished loop hands over to the next engine.
export function useEngineTour(tl, engine, setEngine, enabled) {
  const lastInput = useRef(Date.now()), prevT = useRef(tl.t);
  const [idle, setIdle] = useState(false);
  useEffect(() => {
    const mark = () => { lastInput.current = Date.now(); setIdle(false); };
    const evs = ["pointerdown", "keydown", "wheel", "touchstart"];
    evs.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const iv = setInterval(() => setIdle(Date.now() - lastInput.current > IDLE_MS), 1000);
    return () => { evs.forEach((e) => window.removeEventListener(e, mark)); clearInterval(iv); };
  }, []);
  useEffect(() => {
    const wrapped = tl.t < prevT.current - 2;
    prevT.current = tl.t;
    if (enabled && wrapped && Date.now() - lastInput.current > IDLE_MS) setEngine(ENGINE_ORDER[(ENGINE_ORDER.indexOf(engine) + 1) % ENGINE_ORDER.length]);
  }, [tl.t, enabled, engine, setEngine]);
  return enabled && idle;
}
